module.exports = __webpack_public_path__ + "img/qrcode2.ab0395d7.jpg";